export default "__VITE_ASSET__CUCXDZnU__"